<template>
    <div style="background-color:#f7f8fa">
        <van-row>
            <van-col span="24" style="height:70px">
                <van-card
                    style="background-color:#245086"
                    >
                    <template #desc>
                        <div style="color:white;font-size:10px">{{user.userId}}</div>
                        <div style="color:white;font-size:10px">{{user.orgName}}</div>
                    </template>
                    <template #thumb>
                        <a-avatar style="backgroundColor:#87d068" :size="70" icon="user" />
                        <!-- <img src="../../assets/images/head.jpeg" alt=""> -->
                    </template>
                    <template #title>
                        <div style="color:white;font-size:20px">{{user.name}}</div>
                    </template>
                </van-card>
            </van-col>
            <van-col span="24" style="margin:15px 0px 15px 0px">
                <van-cell-group inset>
                    <van-cell>
                        <template #title>
                            <div style="font-size:20px">我的申请</div>
                        </template>
                    </van-cell>
                    <van-cell >
                        <template>
                            <a-row :gutter="16">
                                <a-col :span="12">
                                    <a-card title="用印">
                                        <a-card-grid style="width:100%;text-align:center">
                                            <a-badge :count="sealApplySize" @click="list('sealApply')">
                                                <a-alert message="流程中"  type="info" show-icon/>
                                            </a-badge>
                                        </a-card-grid>
                                        <a-card-grid style="width:100%;text-align:center">
                                            <a-badge :count="sealApplyEndSize" @click="list('sealApplyEnd')" :number-style="{ backgroundColor: '#52c41a' }">
                                                <a-alert message="办结" type="success" show-icon/>
                                            </a-badge>
                                        </a-card-grid>
                                    </a-card>
                                </a-col>
                                <a-col :span="12">
                                    <a-card title="会议室">
                                        <a-card-grid style="width:100%;text-align:center">
                                            <a-badge :count="meetingApplySize" @click="list('meetingApply')">
                                                <a-alert message="流程中" type="info" show-icon/>
                                            </a-badge>
                                        </a-card-grid>
                                        <a-card-grid style="width:100%;text-align:center">
                                            <a-badge :count="meetingApplyEndSize" @click="list('meetingApplyEnd')" :number-style="{ backgroundColor: '#52c41a' }">
                                                <a-alert message="办结" type="success" show-icon/>
                                            </a-badge>
                                        </a-card-grid>
                                    </a-card>
                                </a-col>
                            </a-row>
                        </template>
                    </van-cell>
                </van-cell-group>
            </van-col>
            <van-col span="24" v-if="permissions.indexOf('collegeOffice:stampsApplication:approve')>-1 || approveUserIds.indexOf(user.userId)>-1">
                <van-cell-group inset>
                    <van-cell>
                        <template #title>
                            <div style="font-size:20px">我的审批</div>
                        </template>
                    </van-cell>
                    <van-cell >
                        <template>
                            <a-row :gutter="16">
                                <a-col :span="12" v-if="permissions.indexOf('collegeOffice:stampsApplication:approve')>-1">
                                    <a-card title="用印">
                                        <a-card-grid style="width:100%;text-align:center">
                                            <a-badge :count="sealTodoSize" @click="list('sealTodo')">
                                            <a-alert message="待办" type="info" show-icon/>
                                            </a-badge>
                                        </a-card-grid>
                                        <a-card-grid style="width:100%;text-align:center">
                                            <a-badge :count="sealTodoEndSize" @click="list('sealTodoEnd')" :number-style="{ backgroundColor: '#52c41a' }">
                                            <a-alert message="办结" type="success" show-icon/>
                                            </a-badge>
                                        </a-card-grid>
                                    </a-card>
                                </a-col>
                                <a-col :span="12" v-if="approveUserIds.indexOf(user.userId)>-1">
                                    <a-card title="会议室">
                                        <a-card-grid style="width:100%;text-align:center">
                                            <a-badge :count="meetingTodoSize" @click="list('meetingTodo')">
                                            <a-alert message="待办" type="info" show-icon/>
                                            </a-badge>
                                        </a-card-grid>
                                        <a-card-grid style="width:100%;text-align:center">
                                            <a-badge :count="meetingTodoEndSize" @click="list('meetingTodoEnd')" :number-style="{ backgroundColor: '#52c41a' }">
                                            <a-alert message="办结" type="success" show-icon/>
                                            </a-badge>
                                        </a-card-grid>
                                    </a-card>
                                </a-col>
                            </a-row>
                        </template>
                    </van-cell>
                </van-cell-group>
            </van-col>
        </van-row>
    </div>
</template>
<script>
    import { sealTodo,meetingApply,meetingTodo,sealApply } from '@/baseAPI/mobile/mobile'
    import { Current } from '@/baseAPI/login'
    import { meetingRoomInfo } from '@/baseAPI/office/meetingRooms'
    import { getDicts } from '@/baseAPI/dictionary'
    export default {
        name: '',
        data () {
            return {
                userId:JSON.stringify(this.$store.state),
                sealApplySize:null,
                sealTodoSize:null,
                meetingApplySize:null,
                meetingTodoSize:null,

                sealApplyEndSize:null,
                sealTodoEndSize:null,
                meetingApplyEndSize:null,
                meetingTodoEndSize:null,
                fileList:[],
                user:null,
                files: [],
                approve:{
                    id:'',
                    approvalStatus:'',
                    approveComments:''
                },
                reviewerArr:[],
                permissions:[],
                approveUserIds:''
            }
        },
        mounted () {
            setTimeout(()=>{
                Current().then(res=>{
                    this.user=res.data;
                    this.permissions = this.user.permissions
                })
                sealApply({status:"commit",current:"1",size:"1"}).then(res=>{
                    this.sealApplySize=res.data.total;
                })
                sealTodo({status:"commit",current:"1",size:"1"}).then(res=>{
                    this.sealTodoSize=res.data.total;
                })
                meetingApply({status:"commit",current:"1",size:"1"}).then(res=>{
                    this.meetingApplySize=res.data.total;
                })
                meetingTodo({status:"commit",current:"1",size:"1"}).then(res=>{
                    this.meetingTodoSize=res.data.total;
                })
                sealApply({status:"end",current:"1",size:"1"}).then(res=>{
                    this.sealApplyEndSize=res.data.total;
                })
                sealTodo({status:"end",current:"1",size:"1"}).then(res=>{
                    this.sealTodoEndSize=res.data.total;
                })
                meetingApply({status:"end",current:"1",size:"1"}).then(res=>{
                    this.meetingApplyEndSize=res.data.total;
                })
                meetingTodo({status:"end",current:"1",size:"1"}).then(res=>{
                    this.meetingTodoEndSize=res.data.total;
                })
                getDicts({dataCode:'HYS',status:true}).then(res=>{
                    res.data.dicts.forEach(e=>{
                        meetingRoomInfo(e.dataCode).then(res=>{
                            this.approveUserIds = this.approveUserIds + res.data.approveUserIds+','
                        })
                    })
                })
            },200)
        },
        methods:{
            list(type){
                this.$router.push('/mobile/list?type='+type)
            }
        }
    }
</script>
<style scoped>
.bg-image
  {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: -10;
  }
</style>